import { Database } from '../Database';
const DB = Database;






// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default (Chatbot: any) => {
	return class Comedian_Bot extends Chatbot {
		readonly name = 'Comedian Bot';
		readonly avatar = 'comedian-bot';
		readonly description = 'Best jokes by the best comedians.';
		
		async getContent() {
			return await DB.getRandomJoke();
		}
	}
}